import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Badge from "@/v2-backoffice-client/components/badge"
import Button from "@/v2-backoffice-client/components/button"
import UptimeConfigCategoryDeleteButton from "@/v2-backoffice-client/uptime/configCategory/delete/UptimeConfigCategoryDeleteButton"
import type { UptimeConfigQuery } from "@/v2-backoffice-client/uptime/config/__types__/uptime.config.query"

type Category = UptimeConfigQuery["getStatusConfig"]["Categories"][number]

export type UptimeConfigCategoryRowProps = ComponentProps<"li"> & {
  category: Category
  platformName: string | undefined
  onEdit(): void
}

function UptimeConfigCategoryRow(props: UptimeConfigCategoryRowProps) {
  const { category, platformName, onEdit, className, ...liProps } = props

  return (
    <li
      className={cn(
        "uptime-config-row",
        !category.IsEnabled && "uptime-config-row-disabled",
        className,
      )}
      {...liProps}
    >
      <div className="uptime-config-row-meta">
        <div className="uptime-config-row-title">
          <span>{category.Name}</span>
          {!category.IsEnabled && (
            <Badge variant="neutral" size="sm">
              Disabled
            </Badge>
          )}
          {category.HasLayerSubCategories && (
            <Badge variant="outline" size="sm">
              Layer sub-cats
            </Badge>
          )}
          {category.IsSharedAcrossPlatforms && (
            <Badge variant="outline" size="sm">
              Shared
            </Badge>
          )}
        </div>
        <div className="uptime-config-row-subtitle">
          <code className="uptime-config-row-id">{category.Id}</code>
          {platformName && <span>· {platformName}</span>}
          <span className="uptime-config-row-priority">
            · Priority {category.Priority}
          </span>
        </div>
        {category.Description && (
          <div className="uptime-config-row-description">
            {category.Description}
          </div>
        )}
        {category.Sources.length > 0 && (
          <div className="uptime-config-row-sources">
            {category.Sources.map((src) => (
              <code key={src} className="uptime-config-source-pill">
                {src}
              </code>
            ))}
          </div>
        )}
      </div>

      <div className="uptime-config-row-actions">
        <Button variant="ghost" size="sm" iconSrc="pencil" onClick={onEdit}>
          Update
        </Button>
        <UptimeConfigCategoryDeleteButton categoryId={category.Id} />
      </div>
    </li>
  )
}

export default UptimeConfigCategoryRow
